import React, { useState } from 'react';
import { BREAKPOINTS } from '../../../constants';
import { useMatchesMinWidth } from '../../hooks/useMatchesMinWidth';
import ModalDrawer from './ModalDrawer';
import Typography, {
  TypographyStates,
  TypographyVariants,
  TypographyWeights,
} from '../../ui-components/Typography/Typography';

const ActiveText = ({
  clickable,
  content,
  title,
  weight = null,
  variant = null,
  modalCustomWidth = null,
  dataLayerEvent = null,
}) => {
  const isDeviceSmallerThanTablet = !useMatchesMinWidth(BREAKPOINTS.TABLET);
  const [containerIsOpen, setContainerIsOpen] = useState(false);

  const formattedContent =
    typeof content === 'object' ? (
      content
    ) : (
      <div className="w-100%" dangerouslySetInnerHTML={{ __html: content }} />
    );

  const contentToShow = (
    <ModalDrawer
      content={formattedContent}
      title={title}
      isOpen={containerIsOpen}
      setIsOpen={setContainerIsOpen}
      isDeviceSmallerThanTablet={isDeviceSmallerThanTablet}
      modalCustomWidth={modalCustomWidth}
    />
  );

  return (
    <React.Fragment>
      {contentToShow}
      <a
        onClick={() => {
          setContainerIsOpen(true);
          dataLayerEvent &&
            dataLayer.push({
              event: dataLayerEvent,
            });
        }}
      >
        <Typography
          variant={variant || TypographyVariants.p2}
          weight={weight || TypographyWeights.regular}
          state={TypographyStates.neutral}
          classNames={'width--fit'}
        >
          {clickable}
        </Typography>
      </a>
    </React.Fragment>
  );
};

export default ActiveText;
